import Carousel from '@mozaic-ds/freemarker/js/modules/_carousel.js';
lm.DOMReady(() => {
  const myCarouselElement = document.getElementById('arm-products-sponsored-carousel');
  new Carousel(myCarouselElement, {
    centerWhenNoButtons: true
  });
});